export default __webpack_public_path__ + "static/media/icon-export.82c3a71e.svg";